import { XEditor } from '@adornis/html-based-buildify/client/editor/x-editor.js';
import { customElement } from 'lit/decorators.js';

/**
 * @customElement cr-editor
 */
@customElement('cr-editor')
export class ChromiumEditor extends XEditor {}
